const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export const isValidTenantId = (id: string) => UUID_REGEX.test(id);

/** Strips quotes, whitespace, and line breaks from .env or URL values. */
export const normalizeTenantId = (raw?: string | null): string | null => {
  if (!raw) return null;
  const cleaned = String(raw).replace(/[\s"'`]/g, "").trim();
  return isValidTenantId(cleaned) ? cleaned : null;
};

export const getEnvTenantId = (): string | null =>
  normalizeTenantId(import.meta.env.VITE_X_TENANTID as string | undefined);
